<template>
  <v-sheet class="mx-auto" max-width="650">
    <span v-if="userId > 0">
      <div class="message-send" v-if="textEnabled === 'loading'">
        <v-skeleton-loader
          height="94"
          type="list-item-two-line"
        ></v-skeleton-loader>
      </div>
      <div class="message-send" v-else-if="textEnabled === true">
        <message :messages="messages" />
      </div>
      <div v-else>
        <p>
          Sending of text messages is not currently enabled. Click on the button
          below, to provision a number, and enable sending.
        </p>
        <v-btn @click="enableSending" class="default-action-btn"
          >Enable Sending</v-btn
        >
      </div>
    </span>
    <span v-else>
      <h2>Select person from the dropdown to the left.</h2>
    </span>
  </v-sheet>
</template>

<script>
import { mapState } from "vuex"
import { UsersAPI, MessagesAPI } from "@/lib/api"
import User from "@/lib/user"
import Message from "@/components/Message"
import eventMixin from "@/mixins/eventMixin"
import titleMixin from "@/mixins/titleMixin"

export default {
  components: { Message },
  mixins: [eventMixin, titleMixin],
  data: function() {
    return {
      textEnabled: false,
      messages: [],
      title: "User Messaging"
    }
  },
  computed: {
    userId: {
      get() {
        return this.$store.state.globals.menteeId
      },
      set(value) {
        this.$store.commit("globals/setMenteeId", value)
      }
    }
  },
  created() {
    if (this.$route.params.id) {
      this.userId = this.$route.params.id
    }

    this.addListener("message:send", ({ userId, body }) => {
      this.sendMessage({ userId, body })
    })

    this.checkTextEnabled()
    this.getMessages()
  },
  mounted: function() {
    this.$cable.subscribe({ channel: "MessagesChannel", room: "public" })
  },
  methods: {
    checkTextEnabled() {
      UsersAPI.get(User.getUserId()).then(response => {
        this.textEnabled = response.texting_enabled
      })
    },
    enableSending() {
      this.textEnabled = "loading"
      this.$forceUpdate()
      MessagesAPI.provision({ userId: User.getUserId() }).then(() => {
        UsersAPI.get(User.getUserId()).then(response => {
          this.textEnabled = response.texting_enabled
          this.$forceUpdate()
        })
      })
    },
    sendMessage({ userId, body }) {
      MessagesAPI.send({ userId, body }).then(() => {
        this.getMessages()
      })
    },
    getMessages() {
      MessagesAPI.list({ userId: this.userId }).then(response => {
        this.messages = response.reverse()
      })
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.params.id) {
      this.userId = to.params.id
      this.getMessages()
    }
    next()
  },
  channels: {
    MessagesChannel: {
      connected() {
        console.log("I am connected to the global messages channel")
      },
      received(data) {
        console.log("received data on channel:")
        console.log(data)
        if (data.from_user_id == this.userId) {
          this.getMessages()
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../scss/variables";
@import "../../scss/buttons";
</style>
